import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./classModalTour.css";

export function startClassFormModalTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour này giúp bạn đi qua các nhóm thông tin chính khi tạo/chỉnh sửa lớp học.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="class-form-header"]',
      title: "Tiêu đề & mục đích",
      description:
        "Xác định bạn đang tạo lớp mới hay chỉnh sửa lớp hiện có. Nút lấp lánh để mở lại tour bất kỳ lúc nào.",
      side: "bottom",
    },
    {
      selector: '[data-tour="class-form-location"]',
      title: "Địa điểm đào tạo",
      description:
        "Chọn chi nhánh, sau đó chọn loại lớp trung tâm hoặc trường học. Nếu là trường học thì chọn thêm đối tác trường.",
      side: "right",
    },
    {
      selector: '[data-tour="class-form-program"]',
      title: "Môn học & khóa học",
      description:
        "Chọn môn trước để nạp danh sách khóa học tương ứng. Mã lớp sẽ sinh theo khóa học khi ở chế độ tạo mới.",
      side: "right",
    },
    {
      selector: '[data-tour="class-form-info"]',
      title: "Thông tin lớp",
      description:
        "Nhập tên/phòng học và khoảng thời gian bắt đầu - kết thúc. Hệ thống sẽ kiểm tra logic ngày học.",
      side: "left",
    },
    {
      selector: '[data-tour="class-form-staffing"]',
      title: "Nhân sự & lịch cố định",
      description:
        "Phân công giáo viên, chọn ngày học trong tuần và khung giờ chuẩn.",
      side: "left",
    },
    {
      selector: '[data-tour="class-form-actions"]',
      title: "Lưu dữ liệu",
      description:
        "Bấm Lưu lớp học để gửi dữ liệu. Nếu thiếu trường bắt buộc, hệ thống sẽ báo lỗi để bạn bổ sung.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy mở modal rồi thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "class-modal-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
